import React from 'react';
export const BenefitsSection = () => {
  return <section className="bg-gradient-to-b from-teal-700 to-teal-800 text-white py-16" data-id="element-15">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-16">
        <h2 className="text-3xl md:text-4xl font-bold mb-8 text-center" data-id="element-17">
          You Won't Just Feel Calmer. You'll Feel <em data-id="element-18">Different.</em>
        </h2>
        <div className="mb-10" data-id="element-19">
          <p className="mb-6 text-lg" data-id="element-20">This program helps you:</p>
          <ul className="list-disc pl-6 space-y-4 mb-10 text-lg" data-id="element-21">
            <li data-id="element-22">Sleep deeper and wake up rested</li>
            <li data-id="element-23">Stop dissociating under stress</li>
            <li data-id="element-24">Feel more present in relationships</li>
            <li data-id="element-25">Get out of chronic freeze, without overwhelm</li>
            <li data-id="element-26">Build real, daily resilience</li>
          </ul>
          <div className="bg-white bg-opacity-10 p-6 rounded-lg italic mb-4" data-id="element-27">
            <p className="mb-4" data-id="element-28">
              "I knew the vagus nerve was important. But Neurotoned is what
              finally helped me <em data-id="element-29">feel</em> it in action. I've tried so many
              somatic programs... this is the first that actually changed how I
              show up in my life."
            </p>
            <p className="text-right" data-id="element-30">
              — Laura D., Social Worker & Trauma Survivor
            </p>
          </div>
        </div>
      </div>
    </section>;
};